// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import Difficulty from "./difficulty_type";

export default {
  matchId: __t.u64(),
  idempotencyKey: __t.string(),
  userId: __t.u64(),
  username: __t.string(),
  countryCode: __t.string(),
  get difficulty() {
    return Difficulty;
  },
  completionTimeMs: __t.u32(),
  bbbv: __t.u16(),
  totalLeftClicks: __t.u32(),
  totalRightClicks: __t.u32(),
  totalChords: __t.u32(),
  effectiveClicks: __t.u32(),
  boardWidth: __t.u8(),
  boardHeight: __t.u8(),
  minesCount: __t.u16(),
  isWin: __t.bool(),
  gameModeId: __t.u8(),
  isPrivate: __t.bool(),
  isFlagged: __t.bool(),
  opponentTimeMs: __t.u32(),
};
